import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarryService {
  private trialName: string | null = null;
  private clientId: string | null = null;
  private groupName: string | null = null;
  private groupId: string | null = null;
  private trialId: string | null = null;
  private geoLocation: string | null = null;
  private selectedDeviceData: any = null;
  private note: string | null = null;
  private deviceDetails: { connectedDeviceId: string; deviceId: string; deviceName: string } | null = null;
  private selectedReplacementDevice: any = null;
  private refreshSubject = new Subject<void>();
  refresh$ = this.refreshSubject.asObservable();

  constructor() { }

  setContext(trialName: string, clientId: string, groupName: string, trialId: string,geoLocation: string) {
    this.trialName = trialName;
    this.clientId = clientId;
    this.groupName = groupName;
    this.trialId = trialId;
    this.geoLocation = geoLocation;
  }

  getTrialName(): string | null {
    return this.trialName;
  }

  getGroupName(): string | null {
    return this.groupName;
  }

  getClientId(): string | null {
    return this.clientId;
  }
  getTrialId(): string | null {
    return this.trialId;
  }
  setGroupId(groupId: string) {
    this.groupId = groupId;
  }

  getGroupId(): string | null {
    return this.groupId;
  }

  getGeoLocation(): string | null {
    return this.geoLocation;
  }

  setSelectedDevice(device: any): void {
    this.selectedDeviceData = device;
  }

  getSelectedDevice(): any | null {
    return this.selectedDeviceData;
  }

  setDeviceNote(note: string): void {
    this.note = note;
  }

  getDeviceNote(): string | null {
    return this.note;
  }

  setDeviceLocation(location: string): void {
    this.geoLocation = location;
  }
  getDeviceLocation(): string | null {
    return this.geoLocation;
  }

  setDeviceDetails(details: { connectedDeviceId: string; deviceId: string; deviceName: string }): void {
    this.deviceDetails = details;
  }

  getDeviceDetails(): { connectedDeviceId: string; deviceId: string; deviceName: string } | null {
    return this.deviceDetails;
  }

  setSelectedReplacementDevice(device: any): void {
    this.selectedReplacementDevice = device;
  }

  getSelectedReplacementDevice(): any | null {
    return this.selectedReplacementDevice;
  }

  triggerRefresh() {
    this.refreshSubject.next();
  }
}
